<template>
    <!-- Container -->
  <section class="container mt-5 mb-5">
    <progress-bar :defaultSite='defaultSite' :step4Active='isActive'></progress-bar>
    <section class="row">
    <div class="col-12">
      <div>
        <h2 class="text-center my-5">Thank you for choosing Trailfinders Travel Insurance</h2>
        <section>
          <div class="col-12">
            <div class="border p-3">
              <p class="fw-bold">Your booking number is: <strong>{{tripDetails.bookingNumber}}</strong></p>
              <p class="fw-bold">A copy of the full policy document has been emailed to <strong>{{tripDetails.email}}</strong></p>
            </div>
          </div>
        </section>

        <section>
          <div class="col-12 mt-5">
            <div class="border p-3">
              <p class="fw-bold" v-if="tripDetails.quoteType === 'SINGLEG'">Departure Date: <strong>{{fromDate}}</strong></p>
              <p class="fw-bold" v-else>Departure Date: <strong>{{tripDetails.departureDate}}</strong></p>
              <p class="fw-bold" v-for="(person, index) in tripDetails.passengers" :key='index'>Passenger:
                <span><br /><strong>{{person['TITLE' + (index + 1)]}} {{person['FIRSTNAME' + (index + 1)]}} {{person['SURNAME' + (index + 1)]}}</strong></span>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
    </section>

  </section>
  <!-- /Container -->
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { logSubmit } from '@/services/api.js'

export default {
  props: ['defaultSite'],
  data() {
    return {
      log: {},
      isActive: true
    }
  },
  async created() {
    if(!this.tripDetails.bookingNumber){
      this.$router.push("/step1")
    }
    const urlParams = new URLSearchParams(window.location.search)
    const isPaidSocial = urlParams.get('PSM') === 'true'
      || urlParams.get('utm_medium') === 'paid-social'
      || document.cookie.split(';').some(c => c.trim().startsWith('smid='))
    const isSocial = urlParams.get('utm_medium') === 'social'
    const eventCategory = isPaidSocial ? 'paid_social' : isSocial ? 'social' : 'organic'

    const { quoteType, fromDate, toDate } = this.tripDetails
    let eventLabel
    if (quoteType === 'ANNUALG') {
      eventLabel = 'annual'
    } else {
      const days = moment(toDate, 'YYMMDD').diff(moment(fromDate, 'YYMMDD'), 'days')
      eventLabel = `${quoteType === 'BACKPACKER' ? 'backpacker' : 'single'}${days}d`
    }

    this.$gtag.event('insurance_confirmation', {
      event_category: eventCategory,
      event_label: eventLabel
    })    
    // Adobe Analytics
    if( typeof window.digitalData !== 'undefined' ) window.digitalData.page.category.subCategory4 = "payment_success"	

    this.log.GUID = this.quoteSingle.GUID
    this.log.EMAIL = this.tripDetails.email
    this.log.COVERTYPE = this.tripDetails.quoteType
    this.log.OPTION = this.quoteSingle.OPTION
    this.log.STAGE = 'Step4 - COMPLETED'
    this.log.STATUS = 'OK'
    this.log.STATUSMSG = 'Payment completed and email confirmation sent'
    await logSubmit(this.log)
  },
  mounted () {
    window.scroll({
      top: 0,
      behavior: 'instant'
    })
  },
  computed: {
    ...mapGetters({	
      tripDetails: 'getTripDetailsInfo',
      quoteSingle: 'getQuoteSingle',
    }),
    fromDate() {
      return moment(this.tripDetails.fromDate, 'YYMMDD').format('D MMMM YYYY')
    },
  }
}
</script>

<style>

</style>